import React from "react";
import styled from "styled-components";
import { FiAlertTriangle, FiArrowRight } from "react-icons/fi";
import { colors } from "./colors";

export default function AlertSummary({ changePct, baselineLabel, criticalCount, linkedEvents, onReview }) {
    const isDown = changePct < 0;
    return (
        <Banner aria-label="Traffic alert" $down={isDown}>
            <Icon $down={isDown} aria-hidden><FiAlertTriangle /></Icon>
            <Text>
                <Headline>
                    Organic clicks are {isDown ? "down" : "up"} {Math.abs(changePct).toFixed(1)}% over the last 7 days
                </Headline>
                <Detail>
                    Compared with the {baselineLabel} baseline.{" "}
                    <Strong>{criticalCount} critical {criticalCount === 1 ? "drop" : "drops"}</Strong>
                    {linkedEvents.map((event) => <span key={event.title}>{" · "}{event.count} linked to {event.title}</span>)}
                </Detail>
            </Text>
            {criticalCount > 0 && (
                <Button type="button" onClick={onReview}>
                    Review critical drops
                    <FiArrowRight aria-hidden />
                </Button>
            )}
        </Banner>
    );
}

const Banner = styled.section`
    display: flex;
    align-items: center;
    gap: 16px;
    border-radius: 12px;
    padding: 16px 20px;
    border: 1px solid ${({ $down }) => ($down ? `${colors.critical}33` : colors.line)};
    background: ${({ $down }) => ($down ? colors.criticalSoft : colors.surface)};
    @media (max-width: 900px) { flex-direction: column; align-items: flex-start; }
    @media (max-width: 600px) { border-radius: 0; border-left: none; border-right: none; }
`;

const Icon = styled.span`
    display: grid;
    place-items: center;
    width: 40px;
    height: 40px;
    flex-shrink: 0;
    border-radius: 8px;
    font-size: 20px;
    background: ${({ $down }) => ($down ? colors.critical : colors.positiveSoft)};
    color: ${({ $down }) => ($down ? "#fff" : colors.positiveInk)};
`;

const Text = styled.div`
    flex: 1;
    min-width: 0;
`;

const Headline = styled.p`
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: ${colors.ink};
`;

const Detail = styled.p`
    margin: 4px 0 0;
    font-size: 14px;
    color: ${colors.muted};
`;

const Strong = styled.span`
    color: ${colors.ink};
`;

const Button = styled.button`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    height: 36px;
    flex-shrink: 0;
    border: none;
    border-radius: 8px;
    padding: 0 16px;
    font-size: 14px;
    font-weight: 500;
    color: #fff;
    background: ${colors.ink};
    cursor: pointer;
    &:hover { background: ${colors.ink}d9; }
`;
